// extracted by mini-css-extract-plugin
export default {"city":"MedicalHistoryForm_city__-1mw1","postal-code":"MedicalHistoryForm_postal-code__NHU4g","submit":"MedicalHistoryForm_submit__H2OF7"};